<template>
  <div class="merchant-form">
    <h1>商家信息填写</h1>
    <form @submit.prevent="handleSubmit">
      <div class="form-group">
        <label for="industry">行业归类:</label>
        <select id="industry" v-model="industry">
          <option value="">请选择行业</option>
          <option value="餐饮">餐饮</option>
          <option value="零售">零售</option>
          <option value="教育">教育</option>
          <option value="科技">科技</option>
          <option value="其他">其他</option>
        </select>
      </div>

      <!-- 归类细分 -->
      <div class="form-group" v-if="industry === '餐饮'">
        <label for="subCategory1">归类细分:</label>
        <select id="subCategory1" v-model="subCategory">
          <option value="">请选择细分类型</option>
          <option value="西餐">西餐</option>
          <option value="中餐">中餐</option>
          <option value="海底捞">海底捞</option>
          <option value="快餐">快餐</option>
        </select>
      </div>

      <div class="form-group" v-else-if="industry === '零售'">
        <label for="subCategory2">归类细分:</label>
        <select id="subCategory2" v-model="subCategory">
          <option value="">请选择细分类型</option>
          <option value="服装">服装</option>
          <option value="家电">家电</option>
          <option value="家居">家居</option>
          <option value="超市">超市</option>
        </select>
      </div>

      <div class="form-group" v-else-if="industry === '教育'">
        <label for="subCategory3">归类细分:</label>
        <select id="subCategory3" v-model="subCategory">
          <option value="">请选择细分类型</option>
          <option value="K12教育">K12教育</option>
          <option value="成人教育">成人教育</option>
          <option value="职业培训">职业培训</option>
        </select>
      </div>

      <div class="form-group" v-else-if="industry === '科技'">
        <label for="subCategory4">归类细分:</label>
        <select id="subCategory4" v-model="subCategory">
          <option value="">请选择细分类型</option>
          <option value="互联网">互联网</option>
          <option value="人工智能">人工智能</option>
          <option value="软件开发">软件开发</option>
        </select>
      </div>

      <div class="form-group" v-else-if="industry === '其他'">
        <label for="subCategory5">归类细分:</label>
        <select id="subCategory5" v-model="subCategory">
          <option value="">请选择细分类型</option>
          <option value="其他1">其他类型1</option>
          <option value="其他2">其他类型2</option>
          <option value="其他3">其他类型3</option>
        </select>
      </div>

      <div class="form-group">
        <label for="shopName">店铺名称:</label>
        <input id="shopName" type="text" v-model="shopName" placeholder="请输入店铺名称" required/>
      </div>

      <!-- 手机号与验证码 -->
      <div class="form-group" id="phone-group">
        <label for="phone">手机号:</label>
        <div class="input-group">
          <input id="phone" type="tel" v-model="phone" placeholder="请输入手机号" required/>
          <button
              type="button"
              :disabled="isCountingDown"
              @click="getCode"
              :class="{ disabled: isCountingDown }"
          >
            {{ isCountingDown ? countdownText : "获取验证码" }}
          </button>
        </div>
      </div>

      <!-- 验证码 -->
      <div class="form-group">
        <label for="smsCode">验证码:</label>
        <input id="smsCode" type="number" v-model="smsCode" placeholder="请输入验证码" required/>
      </div>

      <button type="submit">下一步</button>
    </form>
  </div>
</template>

<script>
import {ref} from "vue";
import {useRouter} from "vue-router";
import api from "../api";
import errorCodes from "@/errorCodes";

export default {
  setup() {
    const industry = ref(""); // 行业归类
    const subCategory = ref(""); // 归类细分
    const shopName = ref("");
    const phone = ref("");
    const smsCode = ref(""); // 用户输入的验证码
    const isCountingDown = ref(false); // 是否处于倒计时状态
    const countdownText = ref("60秒"); // 倒计时按钮文本
    const router = useRouter();
    const serverCode = ref(""); // 服务器返回的验证码
    // 倒计时逻辑
    const startCountdown = () => {
      let countdown = 60;
      isCountingDown.value = true;
      countdownText.value = `${countdown}秒`;

      const timer = setInterval(() => {
        countdown--;
        if (countdown <= 0) {
          clearInterval(timer);
          isCountingDown.value = false;
          countdownText.value = "获取验证码";
        } else {
          countdownText.value = `${countdown}秒`;
        }
      }, 1000);
    };
    const isPhoneValid = (phoneNumber) => {
      // 简单校验：以1开头，后跟10位数字
      const phoneRegex = /^1\d{10}$/;
      return phoneRegex.test(phoneNumber);
    };

    // 调用获取验证码接口
    const getCode = async () => {
      if (!phone.value) {
        alert("请输入手机号！");
        return;
      }
      // 校验手机号格式
      if (!isPhoneValid(phone.value)) {
        alert("手机号格式不正确，请输入有效的11位手机号！");
        return;
      }
      try {
        const response = await api.post("/customer/push_sms_code", {
          cn_number: phone.value,
          code_live_time: "1",
        });
        console.log("验证码发送成功:", response.data);
        alert("验证码已发送！");
        serverCode.value = response.data;

        startCountdown(); // 调用倒计时
      } catch (error) {
        console.error("验证码发送失败:", error);
        alert("验证码发送失败，请重试！");
      }
    };

    // 表单提交
    const handleSubmit = async () => {
      try {
        if (!smsCode.value) {
          alert("请输入验证码！");
          return;
        }
        if (smsCode.value !== serverCode.value) {
          alert("验证码错误，请重新输入！");
          return;
        }
        const payload = {
          store_name: shopName.value,
          store_phone: phone.value,
          store_industry: industry.value,
          store_category: subCategory.value,
        };
        const response = await api.post("/customer/save_to_db", payload);
        console.log(response.data)
        if (response.data.success) {
          alert("信息提交成功！");
          router.push({
            path: "/codePage",
            query: {
              subCategory: subCategory.value,
              shopName: shopName.value, // 添加店铺名称
            },
          });
        } else {
          const errorCode = response.data.error_code;
          const errorMessage = errorCodes[errorCode] || `提交失败，错误原因未知`
          alert(errorMessage);
        }
      } catch (error) {
        console.error("提交信息失败:", error);
        alert("提交失败，请检查网络或稍后重试！");
      }
    };

    return {
      industry,
      subCategory,
      shopName,
      phone,
      smsCode,
      serverCode,
      isCountingDown,
      countdownText,
      handleSubmit,
      getCode,
    };
  },
};
</script>

<style scoped>


.input-group {
  display: flex; /* 使用flex布局，让子元素一行显示 */
  gap: 10px; /* 输入框与按钮之间的间隔 */
  flex: 1; /* 让input-group占满父容器的剩余空间 */
}

.input-group input {
  flex: 2; /* 输入框占据2倍空间 */
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #b3d1ff;
}

.input-group button {
  flex-shrink: 0; /* 按钮不缩小 */
  padding: 10px 15px; /* 调整按钮的内边距 */
  font-size: 14px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.input-group button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
.merchant-form {
  max-width: 400px;
  margin: auto;
  padding: 30px;
  background: #f4faff; /* 浅蓝背景 */
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  font-family: Arial, sans-serif;
}

h1 {
  text-align: center;
  color: #007bff; /* 深蓝标题 */
  font-size: 24px;
  margin-bottom: 30px;
}

.form-group {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

label {
  width: 80px;
  text-align: left;
  font-size: 16px;
  color: #333; /* 深色文本 */
}

input,
select {
  flex: 1;
  padding: 10px;
  font-size: 16px;
  border-radius: 8px;
  border: 1px solid #b3d1ff; /* 浅蓝边框 */
  box-sizing: border-box;
}

input:focus, select:focus {
  outline: none;
  border-color: #007bff; /* 深蓝色聚焦状态 */
}

button[type="button"] {
  margin-left: 10px;
  padding: 8px;
  background-color: #007bff; /* 蓝色按钮 */
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s;
}

button[type="button"]:hover {
  background-color: #0056b3; /* 按钮悬停状态 */
}

button[type="submit"] {
  width: 100%;
  background-color: #007bff; /* 深蓝按钮 */
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px;
  font-size: 16px;
  cursor: pointer;
  margin-top: 20px;
  transition: background-color 0.3s;
}

button[type="submit"]:hover {
  background-color: #0056b3; /* 按钮悬停状态 */
}

button:disabled {
  cursor: not-allowed; /* 禁用鼠标指针 */
  background-color: #ccc; /* 灰色背景 */
  color: #fff; /* 字体颜色变浅 */
}


/* 小屏幕样式优化 */
@media (max-width: 480px) {
  .input-group {
    display: flex; /* 使用flex布局，让子元素一行显示 */
    gap: 40px; /* 输入框与按钮之间的间隔 */
    flex: 1; /* 让input-group占满父容器的剩余空间 */
  }
  .form-group {
    flex-direction: column; /* 保持竖排 */
    align-items: flex-start; /* 强制左对齐 */
  }
  #phone-group label {
    text-align: left; /* 强制左对齐 */
    align-self: flex-start; /* 确保垂直对齐时也靠左 */
  }
  label {
    width: auto;
    margin-bottom: 8px;
  }

  input, select {
    width: 100%;
  }

  .form-group#phone-group {
    display: flex;
    align-items: center;
  }

  #phone {
    flex: 1;
    padding: 10px;
  }

  .form-group button[type="button"] {
    width: auto;
    padding: 8px 12px;
    margin-left: 10px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
  }
}
</style>
